module.exports = __webpack_public_path__ + "static/media/icon_stories.da109a6f.svg";